import React from "react";

export const AddIcon = () => {
    return (<>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.8333 4.16683C10.8333 3.70659 10.4602 3.3335 9.99998 3.3335C9.53974 3.3335 9.16665 3.70659 9.16665 4.16683V9.16683H4.16665C3.70641 9.16683 3.33331 9.53992 3.33331 10.0002C3.33331 10.4604 3.70641 10.8335 4.16665 10.8335H9.16665V15.8335C9.16665 16.2937 9.53974 16.6668 9.99998 16.6668C10.4602 16.6668 10.8333 16.2937 10.8333 15.8335V10.8335H15.8333C16.2935 10.8335 16.6666 10.4604 16.6666 10.0002C16.6666 9.53993 16.2935 9.16683 15.8333 9.16683H10.8333V4.16683Z" fill="currentColor" />
        </svg>
    </>)
}